export const basePalette = {
  blue900: "#1e3a8a",
  blue800: "#1e40af",
  blue500: "#3b82f6",
  blue200: "#99abe6",
  gray900: "#0f172a",
  gray800: "#1e293b",
  gray700: "#334155",
  gray600: "#475569",
  gray500: "#64748b",
  gray300: "#cbd5e1",
  gray200: "#e2e8f0",
  gray100: "#f1f5f9",
  green600: "#16a34a",
  green500: "#40A581",
  lime500: "#BFD732",
  white: "#ffffff",
};

export const lightTheme = {
  mode: "light",
  colors: {
    headerGradient: `linear-gradient(135deg, ${basePalette.blue200} 0%, ${basePalette.blue900} 100%)`,
    sidebarGradient: `linear-gradient(180deg, ${basePalette.gray700} 0%, ${basePalette.gray800} 100%)`,
    bannerGradient: `linear-gradient(90deg, ${basePalette.green500}, ${basePalette.blue900})`,
    textOnDark: basePalette.white,
    textBase: "#0f172a",
    textMutedOnDark: "rgba(255, 255, 255, 0.8)",
    success: basePalette.green600,
    primary: basePalette.blue900,
    primaryHover: basePalette.blue800,
    surface: basePalette.white,
    borderLight: "rgba(255, 255, 255, 0.12)",
    focusRing: "rgba(255, 255, 255, 0.45)",
    shadowMd: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
    shadowSm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    actionBlueBg: "#3b82f6",
    actionBlueHover: "#1e40af",
    actionBlueText: "#ffffff",
    actionWarningBorder: "#d97706",
    actionWarningText: "#d97706",
    actionWarningHoverBg: "#ffc107",
    actionWarningHoverText: "#8a5a00",
    tableDangerRowBg: "rgba(244, 67, 54, 0.08)",
    tableDangerRowBorder: "rgba(244, 67, 54, 0.25)",
    tableDangerRowHoverBg: "rgba(244, 67, 54, 0.14)",
    tableDangerRowAccent: "#dc2626",
    tableSuccessRowBg: "rgba(64, 165, 129, 0.1)",
    tableSuccessRowBorder: "rgba(64, 165, 129, 0.24)",
    tableSuccessRowHoverBg: "rgba(64, 165, 129, 0.16)",
    tableSuccessRowAccent: "#16a34a",
    statusOpenPillBg: "rgba(22, 163, 74, 0.22)",
    statusOpenPillText: "#166534",
    statusClosedPillBg: "rgba(220, 38, 38, 0.2)",
    statusClosedPillText: "#991b1b",
  },
};

export const darkTheme = {
  mode: "dark",
  colors: {
    headerGradient: `linear-gradient(135deg, ${basePalette.gray700} 0%, ${basePalette.gray900} 100%)`,
    sidebarGradient: `linear-gradient(180deg, ${basePalette.gray900} 0%, ${basePalette.gray800} 100%)`,
    bannerGradient: `linear-gradient(90deg, ${basePalette.gray700}, ${basePalette.gray900})`,
    textOnDark: basePalette.white,
    textBase: "#f8fafc",
    textMutedOnDark: "rgba(255, 255, 255, 0.75)",
    success: basePalette.green600,
    primary: basePalette.blue500,
    primaryHover: basePalette.blue200,
    surface: basePalette.gray900,
    borderLight: "rgba(255, 255, 255, 0.08)",
    focusRing: "rgba(255, 255, 255, 0.35)",
    shadowMd: "0 6px 16px rgba(0,0,0,0.35)",
    shadowSm: "0 2px 6px rgba(0,0,0,0.25)",
    actionBlueBg: "#60a5fa",
    actionBlueHover: "#3b82f6",
    actionBlueText: "#0f172a",
    actionWarningBorder: "#f59e0b",
    actionWarningText: "#f59e0b",
    actionWarningHoverBg: "#facc15",
    actionWarningHoverText: "#422006",
    tableDangerRowBg: "rgba(248, 113, 113, 0.22)",
    tableDangerRowBorder: "rgba(248, 113, 113, 0.4)",
    tableDangerRowHoverBg: "rgba(248, 113, 113, 0.3)",
    tableDangerRowAccent: "#f87171",
    tableSuccessRowBg: "rgba(74, 222, 128, 0.18)",
    tableSuccessRowBorder: "rgba(74, 222, 128, 0.35)",
    tableSuccessRowHoverBg: "rgba(74, 222, 128, 0.26)",
    tableSuccessRowAccent: "#4ade80",
    statusOpenPillBg: "rgba(74, 222, 128, 0.44)",
    statusOpenPillText: "#052e16",
    statusClosedPillBg: "rgba(248, 113, 113, 0.46)",
    statusClosedPillText: "#450a0a",
  },
};

export const themeTokens = {
  light: lightTheme,
  dark: darkTheme,
};
